import { render } from "./VerseBackAndForth.vue?vue&type=template&id=85c8e276&ts=true"
import script from "./VerseBackAndForth.vue?vue&type=script&lang=ts"
export * from "./VerseBackAndForth.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__